let browserPublicIp = '';

export function getPublicIp() {
	return browserPublicIp? browserPublicIp: '';
}

export function setPublicIp(ip) {
	browserPublicIp = ip;
}
